import Sex from "../model/Sex";
import Cat from "./Cat";
import Kitten from "./Kitten"
import Litter from "./Litter";


const puppyAdjectives = [
  "suloinen",
  "leikkisä",
  "pehmeä",
  "utelias",
  "ystävällinen",
  "energiainen",
  "pieni",
  "sosiaalinen",
  "herttainen",
  "viaton"
];

function randomIntString(size: number): string {
  const max = Math.pow(10, size) - 1;
  const value = Math.floor(Math.random() * (max + 1)); // random between 0 and max
  return value.toString().padStart(size, '0');
}

function randomChoice<T>(arr: T[]): T {
  if (arr.length === 0) throw new Error('randomChoice called with empty array')
  return arr[Math.floor(Math.random() * arr.length)]
}


function randomChoice2x<T>(arr: T[]): T[] {
  return [
    randomChoice(arr),
    randomChoice(arr),
  ]
}

export function generateCaseUHId(prefix: string = "UHA2025"): string {
  return prefix + "-" + randomIntString(6);
}

// kissat
const andy = new Cat("andy", Sex.male);
const ruby = new Cat("ruby", Sex.female);
const rose = new Cat("rose", Sex.female);

// syyskuu
const autumn_lily = new Kitten("Autumn Lily", false, new Date("2025-09-16")).addPersonality(randomChoice2x(puppyAdjectives));
const snowball = new Kitten("snowball", false).addPersonality(randomChoice2x(puppyAdjectives));
const tyme = new Kitten("tyme", true).addPersonality(randomChoice2x(puppyAdjectives));

// lokakuu
const chio_andy_tricky_tail = new Kitten("Chio Andy Tricky Tail", false, new Date("2025-10-17")).addPersonality(randomChoice2x(puppyAdjectives));
const onion = new Kitten("onion", false).addPersonality(randomChoice2x(puppyAdjectives));
const pumpkin = new Kitten("pumpkin", false).addPersonality(randomChoice2x(puppyAdjectives));

// pentueet
export const litters = {
  syyskuu:  new Litter(
    "syyskuu", 
    andy, 
    rose, 
    [
      autumn_lily,
      snowball, 
      tyme
    ]
  ),
  lokakuu:  new Litter(
    "lokakuu", 
    andy, 
    ruby, 
    [
      chio_andy_tricky_tail,
      onion, 
      pumpkin
    ]
  )
};
